import React, { useState, useEffect, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import swal from 'sweetalert';
import { useHistory } from 'react-router-dom';
import { PostAPI } from 'api/post';
import Cookies from 'universal-cookie';
import { loopBackDomain, loopBackPort } from "environment/environment";
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { RedisDataContext } from "context/RedisDataContext";
import { useSidebar } from "context/SidebarContext.js";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";

const MySearch = (props) => {
  const { t } = useTranslation();
  const searchContainerRef = useRef(null);
  const { expandedSidebar, expandState, handleNavDropDown, isCollapsed } = useSidebar();
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  const [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  const sidebarFeatures = useContext(RedisDataContext);
  const [showCSearch, setShowCSearch] = useState(false);
  const [loadTableData, setLoadTableData] = useState(false);
  const [currentFeature, setCurrentFeature] = useState(null);
  const history = useHistory(); 
  const fields = ['name', 'path'];
  const cookies = new Cookies();
  let urlhost = window.location.host;
  let domain = urlhost.split('.')[0];
  let inputRef = useRef(null);

  const featuresData = (() => {
    try {
      const data = localStorage.getItem('newSidebar');
      return data ? JSON.parse(data) : { data: { features: [] } }; // Default empty structure
    } catch (error) {
      console.error('Error parsing sidebar data from localStorage:', error);
      return { data: { features: [] } };  // Return a default structure if parsing fails
    }
  })();

  useEffect(() => {
    let urlPath = window.location.pathname;
    if (featuresData?.data?.features) {
      featuresData.data.features.forEach(element => {
      if(element.hasOwnProperty('submenuitem')) {
        element.submenuitem.forEach(element => {
        const stringExists = urlPath.includes(element.path);
        if (stringExists) {
          (async () => {
            let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
            const payload = {
              pageTypeID: element.pageTypeId,
              featureID: element.featureId,
              language:  'english'
            };
            cookies.set('feature_id', element.featureId, { path: '/' });
            cookies.set('pagetype_id', element.pageTypeId, { path: '/' });
            // if(isSidebarChanged === false){
              await setGlobalLoadIndicator('1');
              let response = await PostAPI(url, payload);
              await setFeatureBlueprint(response);
              await setGlobalLoadIndicator('2');
              // isSidebarChanged && setInputValue('') 
              return; 
            // }
            return;  
          })()
        }     
        })
      }
      else {
        let payload;
        if(window.location.pathname == '/admin/dashboard/') {
        (async () => {
          let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
          (domain === 'valvoline') ? 
          payload = {
            pageTypeID: 1,
            featureID: 1
          } :
          payload = {
            pageTypeID: 7,
            featureID: 1,
            language:  'english'
          }
          cookies.set('feature_id', 1, { path: '/' });
          (domain === 'valvoline') ? cookies.set('pagetype_id', 1, { path: '/' }) :
          cookies.set('pagetype_id', 7, { path: '/' });
          // if(isSidebarChanged === false){
            await setGlobalLoadIndicator('1');
            let response = await PostAPI(url, payload);
            await setFeatureBlueprint(response);
            await setGlobalLoadIndicator('2');
            return;
          // }
          return;
        })()
        } 
      }
      });
    }
  }, [props.navigateThroughGlobalSearch && window.location.pathname])


  async function getFeatureYMLOnLoad(pageTypeID, featureID, language) {
      let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
      const pageTypeId = {
        pageTypeID: pageTypeID,
        featureID: featureID,
        language : language === 'en' ? 'english' : 'chinese'
      };
      let response = await PostAPI(url, pageTypeId);
      setFeatureBlueprint(() => {
        return response;
      });
  }
 

  const allFeatures = featuresData?.data?.features?.flatMap((feature) =>
    feature.submenuitem
      ? feature.submenuitem.map((item) =>
          Object.keys(item)
            .filter((key) => fields.includes(key))
            .reduce((obj, key) => {
              obj[key] = item[key];
              return obj;
            }, {})
        )
      : []
  ) || [];


  // useEffect(() => {
  //   if (props.navigation.navigateThroughSidebar) {
  //     setInputValue(''); // Reset the search input
  //   }
  // }, [props.navigation.navigateThroughSidebar]);

  const changeInputFunction = (e) => {
    props.onNavigate()
    const query = e.target.value.toLowerCase();
    setInputValue(query);

    if (query) {
      const querySubstring = query.substring(0, 3);
      const filtered = allFeatures.filter((feature) => fields.some((field) => feature[field]?.toLowerCase().startsWith(querySubstring))
      );
      setFilteredSuggestions(filtered);
      setShowCSearch(true);
    } else {
      setFilteredSuggestions([]);
      searchContainerRef.current.classList.remove('active');
      setShowCSearch(false);
    }
  };

  const handleKeyDown = (e) => {
    const query = e.target.value.trim();

    if (e.key === 'Enter') {
      handleClick(query);
      setFilteredSuggestions([]);
    } else if (e.key === ' ') {
      if (query.length === 0) {
        swal({
          title: t('alerts.spaces_not_allowed'),
          text: t('alerts.search_is_restricted'),
          icon: 'warning',
          button: t('alerts.ok'),
        });
      }
    } else if (e.key === 'Backspace' && query.length <= 1) {
      clearSearchData(e);
    }
  };

  const selectSuggestion = async ({name,path}) => {
    history.push(`/admin${path}`);
    setInputValue(name)
    // Find the matching feature or subfeature based on the path
    let matchingFeature = null;
    let matchingSubFeature = null;
  
    // Iterate through features to find a matching subfeature
    if (featuresData?.data?.features) {
        featuresData.data.features.forEach((feature, index) => {
        if (feature.submenuitem) {
          const foundSubFeature = feature.submenuitem.find(subFeature => subFeature.path === path);
          if (foundSubFeature) {
            matchingFeature = { feature, index };
            matchingSubFeature = foundSubFeature;
          }
        }
        });
    }
    
    if (currentFeature?.index !== matchingFeature?.index) {
        handleNavDropDown(matchingFeature.index);
        setCurrentFeature(matchingFeature);
      }
    
    if (matchingSubFeature) {
      const featureID = matchingSubFeature.featureId;
      const pageTypeID = matchingSubFeature.pageTypeId;
      const language = localStorage.getItem('i18nextLng');
      if (featureID && pageTypeID) {
        await setGlobalLoadIndicator('1');
        await getFeatureYMLOnLoad(parseInt(pageTypeID), parseInt(featureID), language)
          .then(() => {
            setGlobalLoadIndicator('2');
          });
      }
    }
  };
  

  const handleClick = (searchQuery) => {
    const query = searchQuery || inputRef.current?.value.trim();
    if (!query) {
      swal({
        title: t('alerts.enter_search'),
        text: t('alerts.value_to_search'),
        icon: 'warning',
        button: t('alerts.ok'),
      });
      return;
    }
    setLoadTableData(false);
    setInputValue(query);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(e.target)
      ) {
        setFilteredSuggestions([]);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const clearSearchData = (e) => {
    e.preventDefault();
    setLoadTableData(false);
    setInputValue(''); // Clear the local input value state
    setFilteredSuggestions([]);
    setShowCSearch(false);
  };

  const renderSearchInput = () => (
    <div className="search-container" ref={searchContainerRef}>
      <input
        ref={inputRef}
        onChange={changeInputFunction}
        onKeyDown={handleKeyDown}
        type="search"
        className="text-line"
        style={{ backgroundColor: 'white' }}
        placeholder="Search Feature"
        autoComplete="on"
        autoFocus
        value={inputValue} // Bind to local state
      />
      {showCSearch ? (
        <i className="fa fa-close icon" onClick={clearSearchData} />
      ) : (
        <i
          className="search fa fa-search"
          aria-hidden="true"
          onClick={() => handleClick()}
        />
      )}
    </div>
  );

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', marginTop: '1rem' }}>
        {renderSearchInput()}
      </div>
      <ul
        className="results-list"
        style={
          filteredSuggestions.length > 0 && inputValue !== ''
            ? { display: 'block' }
            : { display: 'none' }
        }
      >
        {filteredSuggestions.map((suggestion, index) => (
          <li key={index} onClick={() => selectSuggestion(suggestion)}>
            {suggestion.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MySearch;